import { ASIAN_HANDICAP } from "../constants";
import { getConfiguration } from "./configuration";

export function isAsianHandicap(betId) {
    const conf = getConfiguration();
    return  conf.nas && ASIAN_HANDICAP.includes(betId);
}
